export type Locale = "fr" | "pt-BR";

export function isLocale(value: unknown): value is Locale {
  return value === "fr" || value === "pt-BR";
}

export function preferredLocale(languages: readonly string[] = [], country?: string): Locale {
  if (country === "BR") return "pt-BR";
  for (const language of languages) {
    const tag = language.toLowerCase().split("-")[0];
    if (tag === "pt") return "pt-BR";
    if (tag === "fr") return "fr";
  }
  return "fr";
}

export function acceptedLanguages(header = ""): string[] {
  return header.split(",").map((part, index) => {
    const [tag, ...parameters] = part.trim().split(";");
    const quality = parameters.find(value => value.trim().startsWith("q="));
    return { tag, weight: quality ? Number(quality.trim().slice(2)) : 1, index };
  }).filter(value => value.weight > 0 && value.weight <= 1)
    .sort((a, b) => b.weight - a.weight || a.index - b.index)
    .map(value => value.tag);
}
